import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';
//import { ListPage } from '../../pages/list/list';
//import { ListPage } from '../pages/list/list';
import { AuthService } from '../../providers/auth';
import { ListPage } from '../../pages/list/list';
import { ThanksPage } from '../../pages/thanks/thanks';
//import { SignaturePadModule } from 'angular2-signaturepad';

import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { Storage } from '@ionic/storage';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { Camera } from '@ionic-native/camera';

import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  Marker,
  Environment
} from '@ionic-native/google-maps';
@Component({
  selector: 'page-signature',
  templateUrl: 'signature.html'
})
export class SignaturePage {
   loading: Loading;
   obj:any;

  dropbtn:boolean=true;
  
signature = '';
  isDrawing = false;
 items;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  private signaturePadOptions: Object = { // Check out https://github.com/szimek/signature_pad
    'minWidth': 2,
    'canvasWidth': 400,
    'canvasHeight': 200,
    'backgroundColor': '#f6fbff',
    'penColor': '#666a73'
  };



  constructor( public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams,private fileTransfer: FileTransfer,
  private camera: Camera) {
    
    this.items = navParams.get('data');
  console.log(this.items); 
  }
  
  ionViewDidEnter() {
   // this.signaturePad.clear()
   // this.storage.get('savedSignature').then((data) => {
     // this.signature = data;
   // });
   console.log(this.items); 
  }
 
  drawComplete() {
    this.isDrawing = false;
  }
 
  drawStart() {
    this.isDrawing = true;
  }
 clearPad(){
  this.signaturePad.clear();
 }
  savePad() {
    this.signature = this.signaturePad.toDataURL();
   // this.storage.set('savedSignature', this.signature);
    this.signaturePad.clear();
   
  }

  completeride(orderid){
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: '',
              });



              let acceptride22={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"signature":this.signature}
              let data_parameters22=acceptride22;
              let method22='upload_signature.php';

              this.authService.postData(data_parameters22,method22).then((result) => {

                this.obj = result;
                console.log(this.obj);

               if(this.obj.status=='true'){
                this.loading.dismiss();
                 //this.navCtrl.push(RidePage,{ data:itemdata})
                //this.All();
                }
               else{
                this.loading.dismiss();
              //  loading.dismiss();
                //alert(this.obj.message);
                }

                }, (err) => {
                  // Error log
              });
 // Alert Anfang
             let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":5}
                    let data_parameters=acceptride;
                    let method='ride_status.php';
                    this.loading = this.loadingCtrl.create({
                          content: '',
                          });
                    this.authService.postData(data_parameters,method).then((result) => {
                      this.loading.present();
                      this.obj = result;
                      console.log(this.obj);

                     if(this.obj.status=='true'){
                      this.loading.dismiss();
                      this.items.ridestatus=2;
                     this.dropbtn=false;
                     this.navCtrl.setRoot(ThanksPage)
                     //   this.navCtrl.insert(0,ThanksPage);
                     //   this.navCtrl.popToRoot();

                      }

                     else{
                      this.loading.dismiss();
                      //alert(this.obj.message);
                      }

                      }, (err) => {
                        // Error log
                    });
  // Alert Ende
        }
        }
      ]
    });
    alert.present();

  }
  ionViewDidLoad() {


 
     
  }

 
}



// WEBPACK FOOTER //
// ./src/pages/signature/signature.ts